import { trackEvent } from '@Services/analytics/tracking.service';

export const actOnNonUseSocure = (action: string) => {
  trackEvent('Act on Check Docs Action-Sheet', { action });
};
